
// client/src/components/ToggleButtonGroup.jsx
import React from "react";

/**
 * ToggleButtonGroup
 * Single-select row of buttons (Bootstrap styles).
 *
 * props:
 * - options: Array<string | { value: string, label?: string }>
 * - value:   string (current selected value)
 * - onChange: (newValue: string) => void   // safe default provided
 * - className?: string
 * - fullWidth?: boolean
 */
export default function ToggleButtonGroup({
  options = [],
  value,
  onChange = () => {},          // <-- guard: no-op by default
  className = "",
  fullWidth = false,
}) {
  const norm = options.map((opt) =>
    typeof opt === "string"
      ? { value: opt, label: cap(opt) }
      : { value: opt.value, label: opt.label ?? cap(String(opt.value)) }
  );

  return (
    <div
      className={`btn-group ${fullWidth ? "w-100" : ""} ${className}`}
      role="group"
      aria-label="Toggle group"
    >
      {norm.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            className={`btn ${active ? "btn-primary" : "btn-secondary"}`}
            aria-pressed={active}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

function cap(s = "") {
  return s.slice(0, 1).toUpperCase() + s.slice(1);
}
